
import Breadcrumb from '@/components/Breadcrumb'
import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2'

export default {
    components: {
        Breadcrumb,
        TitleBox,
        TitleBox2
    },
    data() {
        return {
            isBaoPei: true,
            submitLoading: false,
            ruleForm: {
                phone: '',
                qq: ''
            },
            rules: {}
        }
    },
    methods: {
        changeBaoPei() {
            this.isBaoPei = !this.isBaoPei
        },
        submitForm() {
            this.$router.push('/confirmOrder/payment')
        }
    }
}
